module.exports = __webpack_public_path__ + "static/media/multi-line.7e3b81bc.png";